export const api = {
  GET_LIST_REFUND_REQUEST: '/index.php?r=api/v1/refund_internal/refund/index',
  SEND_REFUND_REQUEST: '/index.php?r=api/v1/refund_internal/refund/request-refund',
};


export const failedRequest = (ctx, response) => {
  ctx.commit('setProgressTitle', 'Request Failed');
  ctx.commit('setProgressColor', 'red');
  ctx.commit('setPercentage', 0);
  
  const errorMessages = response?.data?.error_message;
  const errorMessageText = Array.isArray(errorMessages)
    ? errorMessages.join(', ')
    : 'Request Internal Refund Failed!';
  ctx.commit(
    'setSnackbar',
    {
      status: true,
      message: errorMessageText,
      icon: 'mdi-alert',
      color: 'red',
    },
    { root: true }
  );
  ctx.commit('setLoading', false);
  return false; 
};

export const successRequest = (ctx, responseData) => {
  ctx.commit('setPercentage', 100);
  ctx.commit('setProgressTitle', 'Request Complete');

  ctx.commit(
    'setSnackbar',
    {
      status: true,
      message: responseData?.message_id || 'Request Internal Refund Successfully !',
      icon: 'mdi-check',
      color: 'green',
    },
    { root: true }
  );

  ctx.commit('setRefundData', responseData.data || {});
  ctx.commit('setLoading', false);
};